<template>
    <div class="row mb-3 justify-content-center w-100">
        <div class="col-12 col-md-12" v-if="Object.keys(zuluAccountList).length > 0 && zuluAccountList.totalRecords > 0">
            <div class="d-flex align-items-center justify-content-between my-3">
                <h2 class="mb-0">My Zulu Account</h2>
                <router-link class="common_btn btn_xs" :to="'/create-zulu-account'"  >Create Zulu Account</router-link>
            </div>
            <div class="table-responsive scrollbar-x">
                <table class="table customize">
                    <thead>
                        <tr>
                            <th>{{$t('dash_tradAccId')}}</th>
                            <th>{{$t('dash_currency')}}</th>
                            <th>{{$t('dash_Platform')}}</th>
                            <th>{{$t('Dlist_demoLive')}}</th>
                            <th>{{$t('Dlist_accountType')}}</th>
                            <th>{{$t('dash_Leverage')}}</th>
                            <th></th> 
                        </tr>
                    </thead>
                    <account-list-table v-if="(!pageLoader1 && liveAccountList != '' && liveAccountList.totalRecords > 0)" :accountlist="liveAccountList.records" :pageLoader="pageLoader1" :listType="'live'"/>
                    <loader-component :pageloader_value="pageLoader1" :type="'table'" :colspan="col_span" :list="liveAccountList" v-else></loader-component>
                </table> 
            </div>
        </div>
        <div class="col-12 col-md-11" v-else>
            <div class="whiteBG">
                <section class="blockElement p-4">
                    <div class="  row justify-content-between align-items-center"> 
                        <div class="col-12 col-md-6">
                            <div class="mamPamm-content">
                            <h2 class="mb-3">{{$t('zulu_trade')}}</h2>
                                <p>{{$t('zulu_zulitradeinfo')}}</p>
                                
                                <div class="d-flex align-items-center mt-3">
                                    <router-link class="common_btn btn_xs mr-2" :to="'/create-zulu-account'">{{$t('zulu_createAccount')}}</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-5">
                            <div class="mamPamm text-center">
                            <img src="../../../../../static/fxView/images/zulu_trade.svg" alt="Zulu Trade">
                            </div>
                        </div> 
                    </div>
                </section> 
                <section class="blockElement p-4 ">
                    <div class="main-title ">
                        <h3>{{$t('zulu_setupzulutrade')}}</h3>
                        <!-- <p>How to setup ZuluTrade account</p> -->
                    </div> 
                    <div class="mamPamm-feature mt-4 ">
                        <ul class="listing flexible">
                            <li>
                                <feather type="check"></feather>
                                <p class="m-0">{{$t('zulu_registeropen')}}</p>
                            </li>
                            <li>
                                <feather type="check"></feather>
                                <p class="m-0">{{$t('zulu_findaccount')}}</p>
                            </li>
                            
                            <li>
                                <feather type="check"></feather>
                                <p class="m-0">{{$t('zulu_logintozulu')}}</p>
                            </li>
                        </ul>
                    </div> 
                </section>
            </div>
        </div>
    </div>
</template>
<script>
    import account_list_table from '../../shared/tradingAccounts/account-list-table'
    export default {
        name: 'Api Trading',
        data() {
            return {
                pageLoader1 : false,
                showButtonDetailInfo : ''
            }
        },
        components: {
            accountListTable : account_list_table
        },
        methods:{
            detailDiv(index,getData,account_id,act_account_id) {
                if(getData == 'div'){
                    var element = document.getElementById(getData+index)
                    if ($(element).hasClass('hide')){
                        $(element).removeClass('hide');
                    }else{
                        $(element).addClass('hide');
                    } 
                }else{
                    if(parseInt(this.showButtonDetailInfo) == index){
                        this.showButtonDetailInfo = ''
                    }else{
                        this.showButtonDetailInfo = index
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/socialTrade/pages/zulu_trade.vue